(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      section.querySelectorAll('[data-gallery-index]').forEach(button => button.addEventListener('click', () => {
        const index = button.dataset.galleryIndex;
        section.querySelectorAll('[data-gallery-slide]').forEach(slide => { slide.hidden = slide.dataset.gallerySlide !== index; });
        section.querySelectorAll('[data-gallery-index]').forEach(thumb => {
          thumb.classList.toggle('active', thumb === button);
          thumb.setAttribute('aria-pressed', String(thumb === button));
        });
      }));
      const updateVariant = option => {
        if (!option) return;
        const price = section.querySelector('[data-product-price]');
        const add = section.querySelector('[data-add-button]');
        const availability = section.querySelector('[data-availability]');
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        if (add) add.disabled = option.dataset.available !== 'true';
        if (availability) availability.textContent = option.dataset.available === 'true' ? availability.dataset.inStock : availability.dataset.soldOut;
        const url = new URL(location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState(null, '', url);
      };
      const variants = section.querySelector('[data-variant-select]');
      if (variants) variants.addEventListener('change', () => updateVariant(variants.selectedOptions[0]));
      section.querySelectorAll('[data-variant-radio]').forEach(radio => radio.addEventListener('change', () => updateVariant(radio)));
      const quantity = section.querySelector('.product-quantity .quantity-input');
      section.querySelector('[data-quantity-minus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) - 1); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
      section.querySelector('[data-quantity-plus]')?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value || 1) + 1); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
    });
    scope.querySelectorAll('[data-shop]').forEach(shop => {
      if (shop.dataset.ready || !shop.querySelector('[data-demo-grid]')) return;
      shop.dataset.ready = 'true';
      const grid = shop.querySelector('[data-demo-grid]');
      const items = Array.from(grid.children);
      const url = new URL(location.href);
      let category = url.searchParams.get('category') || 'All';
      let colour = 'All';
      const selectCategory = value => {
        category = value;
        shop.querySelectorAll('input[name="demo-category"]').forEach(input => { input.checked = input.value === value; });
        shop.querySelectorAll('[data-category-link]').forEach(link => {
          link.classList.toggle('active', link.dataset.categoryLink === value);
          if (link.dataset.categoryLink === value) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
        });
      };
      function apply() {
        let visible = 0;
        items.forEach(item => {
          const card = item.querySelector('[data-category]');
          const broad = ['All', 'New Arrivals', 'Best Sellers'].includes(category);
          const show = (broad || card.dataset.category === category) && (colour === 'All' || card.dataset.colour === colour);
          item.hidden = !show;
          if (show) visible++;
        });
        shop.querySelector('[data-empty]').hidden = visible !== 0;
      }
      selectCategory(category);
      apply();
      shop.querySelectorAll('[data-category-link]').forEach(link => link.addEventListener('click', e => {
        e.preventDefault(); selectCategory(link.dataset.categoryLink); apply();
        const next = new URL(location.href);next.searchParams.set('category', category);history.replaceState(null, '', next);
      }));
      shop.querySelectorAll('input[name="demo-category"]').forEach(input => input.addEventListener('change', () => { selectCategory(input.value); apply(); }));
      shop.querySelectorAll('input[name="demo-colour"]').forEach(input => input.addEventListener('change', () => { colour = input.value; apply(); }));
      shop.querySelector('[data-clear-filters]').addEventListener('click', () => {
        selectCategory('All');colour = 'All';
        shop.querySelectorAll('input[name="demo-colour"]').forEach(input => { input.checked = input.value === 'All'; });apply();
      });
      shop.querySelector('[data-demo-sort]').addEventListener('change', e => {
        const order = [...items];
        if (e.target.value !== 'featured') order.sort((a, b) => {
          const delta = Number(a.querySelector('[data-price]').dataset.price) - Number(b.querySelector('[data-price]').dataset.price);
          return e.target.value === 'low' ? delta : -delta;
        });
        order.forEach(item => grid.appendChild(item));
      });
    });
    const current = new URL(location.href);
    scope.querySelectorAll('.desktop-nav>a,.desktop-nav .nav-shop>a').forEach(link => {
      const target = new URL(link.href);
      if (target.pathname === current.pathname && target.searchParams.get('view') === current.searchParams.get('view')) link.setAttribute('aria-current', 'page');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

/* SABAAYAT HERO SLIDER START */
(() => {
  function initSabaayatSliders(root=document){
    root.querySelectorAll('[data-sabaayat-slider]').forEach(slider=>{
      if(slider.dataset.heroReady==='true') return;
      slider.dataset.heroReady='true';
      const track=slider.querySelector('[data-slider-track]');
      const slides=[...slider.querySelectorAll('[data-slider-slide]')];
      const dots=[...slider.querySelectorAll('[data-slider-dot]')];
      if(!track||slides.length<2) return;
      let index=0,timer=null,startX=null,lastX=null;
      const interval=Math.max(4000,Number(slider.dataset.interval)||6000);
      const autoplay=slider.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches;
      const render=()=>{track.style.transform=`translate3d(-${index*100}%,0,0)`;dots.forEach((d,i)=>d.classList.toggle('is-active',i===index));};
      const go=i=>{index=(i+slides.length)%slides.length;render();};
      const stop=()=>{if(timer){clearInterval(timer);timer=null;}};
      const start=()=>{stop();if(autoplay)timer=setInterval(()=>go(index+1),interval);};
      slider.querySelector('[data-slider-prev]')?.addEventListener('click',()=>{go(index-1);start();});
      slider.querySelector('[data-slider-next]')?.addEventListener('click',()=>{go(index+1);start();});
      dots.forEach((dot,i)=>dot.addEventListener('click',()=>{go(i);start();}));
      slider.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse')return;startX=lastX=e.clientX;stop();},{passive:true});
      slider.addEventListener('pointermove',e=>{if(startX!==null)lastX=e.clientX;},{passive:true});
      slider.addEventListener('pointerup',()=>{if(startX!==null&&Math.abs(lastX-startX)>45)go(index+(lastX<startX?1:-1));startX=lastX=null;start();},{passive:true});
      slider.addEventListener('mouseenter',stop);slider.addEventListener('mouseleave',start);
      slider.addEventListener('focusin',stop);slider.addEventListener('focusout',start);
      render();start();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initSabaayatSliders());else initSabaayatSliders();
  document.addEventListener('shopify:section:load',e=>initSabaayatSliders(e.target));
})();
/* SABAAYAT HERO SLIDER END */
